// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1783575952061
      var cssReload = require("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./scss/tailwind.scss
// module id = 1331
// module chunks = 58